const mensagens = {
	variaveis: 'Variáveis',
	'variaveis-meteorologicas': 'Variáveis Meteorológicas',
	'variavel.precipitacao': 'Precipitação',
	'variavel.evapotranspiracao': 'Evapotranspiração',
	'variavel.precipitacao-ac': 'Precipitação acumulada',
	'variavel.precipitacao-acumulada': 'Precipitação acumulada 24h',
	'variavel.precipitacao.unidade': 'mm',
	'variavel.precipitacao.titulo-meteograma': 'Precipitação (mm)',
	'variavel.temperatura': 'Temperatura',
	'variavel.agua': 'Água',
	'variavel.temperatura.unidade': 'ºC',
	'variavel.agua.unidade': '%',
	'variavel.temperatura.titulo-meteograma': 'Temperatura (ºC)',
	'variavel.agua.titulo-meteograma': 'Água (%)',
	'variavel.pressao': 'Pressão',
	'variavel.pressao.unidade': 'hPa',
	'variavel.pressao.titulo-meteograma': 'Pressão (hPa)',
	'variavel.umidade': 'Umidade',
	'variavel.umidade.unidade': '%',
	'variavel.umidade.titulo-meteograma': 'Umidade (%)',
	'variavel.vento': 'Vento',
	'variavel.velocidade': 'Velocidade',
	'variavel.velocidade.unidade': 'm/s',
	'variavel.vento.velocidade': 'Velocidade do vento',
	'variavel.vento.velocidade.unidade': '(m/s)',
	'variavel.vento.titulo-meteograma': 'Vento (m/s)',
	'variavel.direcao': 'Direção',
	'variavel.direcao.unidade': 'º',
	'variavel.vento.direcao': 'Direção do vento',
	'variavel.vento.direcao.unidade': '(°)',
	'variavel.nebulosidade': 'Nebulosidade',
	'variavel.nebulosidade.unidade': '%',
	'variavel.nebulosidade.titulo-meteograma': 'Nebulosidade (%)',
	'variavel.baixa': 'Baixa',
	'variavel.nebulosidade.baixa': 'Nebulosidade baixa',
	'variavel.media': 'Média',
	'variavel.nebulosidade.media': 'Nebulosidade média',
	'variavel.alta': 'Alta',
	'variavel.nebulosidade.alta': 'Nebulosidade alta',
	'variavel.pressaoAtmosferica': 'Pressão atmosférica',
	'variavel.fluxoCalor': 'Fluxo de calor',
	'variavel.fluxoCalor.unidade': 'mV',
	'variavel.temperaturaInterna': 'Temperatura interna',
	'variavel.temperaturaAr': 'Temperatura do ar',
	'variavel.temperaturaSolo': 'Temperatura do solo',
	'variavel.temperaturaSolo10cm': 'Temperatura do solo 10 cm',
	'variavel.temperaturaSolo20cm': 'Temperatura do solo 20 cm',
	'variavel.temperaturaSolo30cm': 'Temperatura do solo 30 cm',
	'variavel.temperaturaSolo40cm': 'Temperatura do solo 40 cm',
	'variavel.temperaturaSolo50cm': 'Temperatura do solo 50 cm',
	'variavel.temperaturaSolo60cm': 'Temperatura do solo 60 cm',
	'variavel.conteudoAguaSolo10cm': 'Conteúdo de água no solo 10 cm',
	'variavel.conteudoAguaSolo20cm': 'Conteúdo de água no solo 20 cm',
	'variavel.conteudoAguaSolo30cm': 'Conteúdo de água no solo 30 cm',
	'variavel.conteudoAguaSolo40cm': 'Conteúdo de água no solo 40 cm',
	'variavel.conteudoAguaSolo50cm': 'Conteúdo de água no solo 50 cm',
	'variavel.conteudoAguaSolo60cm': 'Conteúdo de água no solo 60 cm',
	'variavel.temperaturaMaxima': 'Temperatura Máxima',
	'variavel.temperaturaMinima': 'Temperatura Mínima',
	'variavel.umidadeInterna': 'Umidade interna',
	'variavel.umidadeRelativa': 'Umidade relativa',
	'variavel.umidadeAr': 'Umidade do ar',
	'variavel.umidadeMaxima': 'Umidade máxima',
	'variavel.umidadeMinima': 'Umidade mínima',
	'variavel.pontoOrvalhoInstantaneo': 'Ponto de orvalho instantâneo',
	'variavel.pontoOrvalhoMaximo': 'Ponto de orvalho máximo',
	'variavel.pontoOrvalhoMinimo': 'Ponto de orvalho mínimo',
	'variavel.pressaoInstantanea': 'Pressão instantânea',
	'variavel.pressaoMaxima': 'Pressão máxima',
	'variavel.pressaoMinima': 'Pressão mínima',
	'variavel.rajadaVento': 'Rajada de vento',
	'variavel.radiacaoSolar': 'Radiação solar',
	'variavel.radiacaoSolar.unidade': 'W/m²',
	'variavel.radiacaoSolar.titulo-meteograma': 'Radiação solar ( W/m² )',
	'variavel.vento.direcao-desvio-padrao': 'Desvio padrão da direção',
};

export default mensagens;
